import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import FrequentlyAskedQuestionsModal from './FrequentlyAskedQuestionsModal'
import EmailCustomerSupportModal from './EmailCustomerSupportModal'
import PrivacyPolicyModal from './PrivacyPolicyModal'
import TermsAndConditionsModal from './TermsAndConditionsModal'
import AcknowledgementsModal from './AcknowledgementsModal'
import PushNotificationPopup from './PushNotificationPopup'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import BecomeAStylistModal from './BecomeAStylistModal'
import CancellationPolicyModal from './CancellationPolicyModal'
import LegalNoticesModal from './LegalNoticesModal'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const SupportModal = ({ handleSupportModal, supportModal = false }) => {
  const [user, setUser] = React.useState(null)
  React.useEffect(() => {
    let user = {
      userType: 'client',
    }
    setUser(user)
  }, [])

  const [
    frequentlyAskedQuestionsModal,
    setFrequentlyAskedQuestionsModal,
  ] = React.useState(false)
  const [emailCustomerSupport, setEmailCustomerSupport] = React.useState(false)
  const [privacyPolicyModal, setPrivacyPolicyModal] = React.useState(false)
  const [cancellationPolicyModal, setCancellationPolicyModal] = React.useState(
    false,
  )
  const [termsAndConditions, setTermsAndConditions] = React.useState(false)
  // const [toggleLegalNoticesModal, setToggleLegalNoticesModal] = React.useState(
  //   false,
  // )
  const [acknowledgementsModal, setAcknowledgementsModal] = React.useState(
    false,
  )
  const [testPushNotification, setTestPushNotification] = React.useState(false)
  const [
    toggleBecomeAStylistModal,
    setToggleBecomeAStylistModal,
  ] = React.useState(false)

  const handleFrequentlyAskedQuestionsModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setFrequentlyAskedQuestionsModal(!frequentlyAskedQuestionsModal)
  }

  const handleEmailCustomerSupportModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setEmailCustomerSupport(!emailCustomerSupport)
  }

  const handlePrivacyPolicyModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setPrivacyPolicyModal(!privacyPolicyModal)
  }

  const handleCancellationPolicyModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setCancellationPolicyModal(!cancellationPolicyModal)
  }

  const handleTermsAndConditionsModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setTermsAndConditions(!termsAndConditions)
  }

  const handleAcknowledgementsModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setAcknowledgementsModal(!acknowledgementsModal)
  }

  // const handleLegalNoticesModal = () => {
  //   if (supportModal) {
  //     handleSupportModal(false)
  //   }
  //   setToggleLegalNoticesModal(!toggleLegalNoticesModal)
  // }

  const handlePushNotificationsModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setTestPushNotification(!testPushNotification)
  }

  const handleBecomeAStylistModal = () => {
    if (supportModal) {
      handleSupportModal(false)
    }
    setToggleBecomeAStylistModal(!toggleBecomeAStylistModal)
  }

  return (
    <div>
      <Modal
        open={supportModal}
        onClose={() => handleSupportModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="support-modal">
          <div>
            <h3 className="fs-24 mb-3 fw-bold">Support</h3>
            <div className="mb-5">
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handleFrequentlyAskedQuestionsModal}
              >
                <p className="fs-16 m-0">Frequently Asked Questions</p>
                <ChevronRightIcon />
              </div>
              {user?.userType !== 'client' && (
                <Link to={'/chat'} className="text-decoration-none text-black">
                  <div className="d-flex justify-content-between align-items-center px-1 py-2 pointer">
                    <p className="fs-16 m-0">Customer Support Chat</p>
                    <ChevronRightIcon />
                  </div>
                </Link>
              )}
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handleEmailCustomerSupportModal}
              >
                <p className="fs-16 m-0">Email Customer Support</p>
                <ChevronRightIcon />
              </div>
              {/* {user?.userType === 'client' && (
                <div
                  className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                  onClick={handleBecomeAStylistModal}
                >
                  <p className="fs-16 m-0">Become a Stylist</p>
                  <ChevronRightIcon />
                </div>
              )} */}
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handlePrivacyPolicyModal}
              >
                <p className="fs-16 m-0">Privacy Policy</p>
                <ChevronRightIcon />
              </div>
              <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handleTermsAndConditionsModal}
              >
                <p className="fs-16 m-0">Terms & Conditions</p>
                <ChevronRightIcon />
              </div>
              {user?.userType !== 'client' && (
                <div
                  className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                  onClick={handleAcknowledgementsModal}
                >
                  <p className="fs-16 m-0">Acknowledgements</p>
                  <ChevronRightIcon />
                </div>
              )}
              {user?.userType === 'client' && (
                <div>
                  <div
                    className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                    onClick={handleCancellationPolicyModal}
                  >
                    <p className="fs-16 m-0">Cancellation Policy</p>
                    <ChevronRightIcon />
                  </div>
                  {/* <div
                    className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                    // onClick={handleLegalNoticesModal}
                  >
                    <p className="fs-16 m-0">Legal Notices</p>
                    <ChevronRightIcon />
                  </div> */}
                </div>
              )}
              {/* <div
                className="d-flex justify-content-between align-items-center px-1 py-2 pointer"
                onClick={handlePushNotificationsModal}
              >
                <p className="fs-16 m-0">Test Push Notifications</p>
                <ChevronRightIcon />
              </div> */}
            </div>
            <Button
              disableElevation
              fullWidth
              id="btn-primary-no-shadow"
              className="pointer"
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
        <FrequentlyAskedQuestionsModal
          handleFrequentlyAskedQuestionsModal={
            handleFrequentlyAskedQuestionsModal
          }
          modalOpen={frequentlyAskedQuestionsModal}
        />
        <EmailCustomerSupportModal
          handleEmailCustomerSupportModal={handleEmailCustomerSupportModal}
          modalOpen={emailCustomerSupport}
        />
        <PrivacyPolicyModal
          handlePrivacyPolicyModal={handlePrivacyPolicyModal}
          modalOpen={privacyPolicyModal}
        />
        <CancellationPolicyModal
          handleCancellationPolicyModal={handleCancellationPolicyModal}
          modalOpen={cancellationPolicyModal}
        />
        <TermsAndConditionsModal
          handleTermsAndConditionsModal={handleTermsAndConditionsModal}
          modalOpen={termsAndConditions}
        />
        <AcknowledgementsModal
          handleAcknowledgementsModal={handleAcknowledgementsModal}
          modalOpen={acknowledgementsModal}
        />
        <PushNotificationPopup
          handlePushNotificationsModal={handlePushNotificationsModal}
          modalOpen={testPushNotification}
        />
        <BecomeAStylistModal
          handleBecomeAStylistModal={handleBecomeAStylistModal}
          toggleBecomeAStylistModal={toggleBecomeAStylistModal}
        />
        {/* <LegalNoticesModal
          handleLegalNoticesModal={handleLegalNoticesModal}
          toggleLegalNoticesModal={toggleLegalNoticesModal}
        /> */}
    </div>
  )
}

export default SupportModal
